export const FETCH_POLICIES_REQUEST = "FETCH_POLICIES_REQUEST";
export const FETCH_POLICIES_SUCCESS = "FETCH_POLICIES_SUCCESS";
export const FETCH_POLICIES_FAIL = "FETCH_POLICIES_FAIL";

export const FETCH_EMP_TYPES_REQUEST = "FETCH_EMP_TYPES_REQUEST";
export const FETCH_EMP_TYPES_SUCCESS = "FETCH_EMP_TYPES_SUCCESS";
export const FETCH_EMP_TYPES_FAIL = "FETCH_EMP_TYPES_FAIL";